import request from '../request';

export const getOutputTrip = (tripId = '') => {
  return request.get(`outputs/trip/${tripId}`).then((res) => res);
};
